import { render, staticRenderFns } from "./DeviceDiskonek.vue?vue&type=template&id=5c656cd5&scoped=true&"
import script from "./DeviceDiskonek.vue?vue&type=script&lang=js&"
export * from "./DeviceDiskonek.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDiskonek.vue?vue&type=style&index=0&id=5c656cd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c656cd5",
  null
  
)

export default component.exports